/* eslint-disable no-console */
import { takeLatest, put } from 'redux-saga/effects';
import * as TypeActions from '../store/jornada/actionsTypes';
import BaseService from '../services/BaseService';
import * as ToastTypeActions from '../store/toast/actionsTypes';
import * as LoaderTypeActions from '../store/loader/actionsTypes';
import fileDownload from 'js-file-download';

function* loadJornada({ id }) {
  try {
    yield put({ type: LoaderTypeActions.LOADER_SHOW });
    const response = yield BaseService.get({ url: `jornadas/${id}` });
    yield put({
      type: TypeActions.FETCH_JORNADA_SUCCESS,
      data: response.data,
    });
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
  } catch (error) {
    yield console.log(error);
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_ERROR,
      message: 'Erro ao carregar as informações!',
    });
  }
}

function* save({ data, callback }) {
  try {
    yield put({ type: LoaderTypeActions.LOADER_SHOW });
    const response = data.id
      ? yield BaseService.put({ url: `jornadas/${data.id}`, data })
      : yield BaseService.post({ url: 'jornadas', data });
    yield put({
      type: TypeActions.SAVE_JORNADA_SUCCESS,
      data: response.data,
    });
    yield callback();
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
  } catch (error) {
    yield console.log(error);
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_ERROR,
      message: 'Erro ao salvar as informações!',
    });
  }
}

function* exportJornadas({ filtro, callback }) {
  try {
    yield put({ type: LoaderTypeActions.LOADER_SHOW });
    const response = yield BaseService.execute({
      url: 'jornadas/export',
      method: 'POST',
      data: filtro,
      options: {
        responseType: 'blob',
      },
    });

    let name = 'Jornada Medicao.xlsx';
    if (filtro.tipoControle === 'FOLHA_PONTO') {
      name = 'Jornada.xlsx';
    }

    yield fileDownload(response.data, name);
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_SUCCESS,
      message: 'Exportação realizada com sucesso!',
    });
    yield callback();
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
  } catch (error) {
    yield console.log(error);
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_ERROR,
      message: 'Erro ao exportar as informações!',
    });
  }
}

function* deleteById({ id, callback }) {
  try {
    yield put({ type: LoaderTypeActions.LOADER_SHOW });
    yield BaseService.delete({ url: `jornadas/${id}` });
    yield put({ type: TypeActions.JORNADA_DELETE_SUCCESS, id });
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_SUCCESS,
      message: 'Informações removidas com sucesso!',
    });
    yield callback();
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
  } catch (error) {
    yield console.log(error);
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_ERROR,
      message: 'Erro ao deletar!',
    });
  }
}

function* downloadJornadas({ filter, callback }) {
  try {
    yield put({ type: LoaderTypeActions.LOADER_SHOW });
    const response = yield BaseService.execute({
      url: 'jornadas/download',
      data: filter,
      method: 'POST',
      options: {
        responseType: 'blob',
      },
    });
    yield fileDownload(response.data, 'jornada_medicao.zip');
    yield callback(response.data);
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_SUCCESS,
      message: 'Download gerado com sucesso!',
    });
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
  } catch (error) {
    yield console.log(error);
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_ERROR,
      message: 'Erro ao gerar o download!',
    });
  }
}

export default function* watchJornada() {
  yield takeLatest(TypeActions.FETCH_JORNADA, loadJornada);
  yield takeLatest(TypeActions.SAVE_JORNADA, save);
  yield takeLatest(TypeActions.EXPORT_JORNADAS, exportJornadas);
  yield takeLatest(TypeActions.JORNADA_DELETE, deleteById);
  yield takeLatest(TypeActions.JORNADA_DOWNLOAD, downloadJornadas);
}
